import { memo, useEffect, useCallback, useState, useMemo } from 'react';
import { BzToolTip } from '../../../components';
import SideContent from './SideContent';
import { SIDE_TRAY_EXPAND_PERCENTAGE, FACILITY_NUM, APP_INFO_PARAMS, NEWS_CMOT_MODE, LOCAL_STORAGE_KEYS, GLOBAL_FUNCTION_TYPES } from '../../../utils/global_variables';
import { useDispatch, useSelector } from 'react-redux';
import { WATCHLIST_GRID_REF, bIsProd, getAppInfoData, getDecryptLocalStorage, globalFunctionsEventDispatcher, isGuestUser, isUserIsAGuest } from '../../../utils/global_functions';
import { toastConfig } from '../../../redux/actions/toast';
import { _resetGridFeatures } from '../../../controllers/watchlist';
import { useWFHMessages } from '../../../hooks';



const SideMenu = (props) => {
    const dispatch = useDispatch();

    const dontMissData = useSelector(state => state?.dontMiss?.dontMissData);
    const objCFT = useSelector(state => state?.auth?.objCFT);
    const appInfo = useSelector(state => state?.appInfo?.appInfo);
    const { hamburgerMenu: objHamburgerMenu = {} } = useSelector(state => state.appInfo.dynamicMenus);

    const nCMOTMode = getAppInfoData(APP_INFO_PARAMS.APP_CMOT_MODE, appInfo);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    //Azeem Khan : 24-04-2024 : BT-107432 -  Breeze - Alerts - Start
    const nTriggerAlertCountFromRedux = useSelector(state => state?.alerts?.nTriggerAlertCountFromRedux);
    const nTriggerAlertCount = useMemo(() => localStorage.getItem(LOCAL_STORAGE_KEYS.TRIGGER_ALERT_COUNT + objLoginSession?.data?.user_id), [nTriggerAlertCountFromRedux]);
    //Azeem Khan : 24-04-2024 : BT-107432 -  Breeze - Alerts - End
    const [nDontMissCount, setNDontMissCount] = useState(0);
    useEffect(() => {
        setNDontMissCount(dontMissData?.length - getDecryptLocalStorage('SEEN_DONT_MISS'));
    }, [dontMissData,]);
    const handleDontMissCount = () => {
        setNDontMissCount(0);
    };

    // ---BT-113521_SrikanthRao_17-07-2023-Start

    // {/* Vinit R : 21-02-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- Start */ }
    const arrSideMenu = [
        { id: '1', name: 'OVERVIEW', icon: <div className='icon-16 icon-eye icon-light onactive'></div>, tooltip: 'Overview' },
        { id: '11', name: 'ORDER_TICKET', icon: <div className='icon-16 icon-buysell icon-light'></div>, tooltip: 'Order Ticket' },
        { id: '2', name: 'CHART', icon: <div className='icon-16 icon-chart icon-light onactive'></div>, tooltip: 'Chart' },
        { id: '3', name: 'SCREENER', icon: <div className='icon-16 icon-screener icon-light onactive'></div>, tooltip: 'Screeners' }, //Prachi T [07-12-2023] - commented for 1st release to hide SCREENER from Watchlist sidetray
        { id: '4', name: 'RECOMMENDATIONS', icon: <div className='icon-16 icon-recommendations icon-light onactive'></div>, tooltip: 'Recommendations' },
        { id: '6', name: 'DONT_MISS', icon: <div onClick={handleDontMissCount}><div className='icon-16 icon-dontmiss icon-light onactive'></div>{nDontMissCount > 0 && <div className='sticky-notification-count'>{nDontMissCount}</div>}</div>, tooltip: 'Don’t Miss' },
        { id: '7', name: 'ORDERS_POSITIONS', icon: <div className='icon-16 icon-positions icon-light onactive'></div>, tooltip: 'Orders, Position and Holdings' },//Vaibhav Singh: 05-02-24: BT-104814: Tooltip Updated here  //Prachi T [07-12-2023] - commented for 1st release to hide Orders,Positions and Holdings from Watchlist sidetray
        { id: '8', name: 'FUNDS', icon: <div className='icon-16 icon-funds icon-light onactive'></div>, tooltip: 'Funds' },
        { id: '10', name: 'CALCULATORS', icon: <div className='icon-16 icon-calculators icon-light onactive'></div>, tooltip: 'Calculators' },
        // { id: '11', name: 'WRITE_SAVE_NOTES', icon: <div className='icon-16 icon-notes icon-light onactive'></div>, tooltip: 'Notes' },
    ];
    // {/* Vinit R : 21-02-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- End */ }


    const filteredArray = arrSideMenu.filter(item => {
        // const isProd = bIsProd();
        // if (isProd) {
        //     return item.id !== '1' && item.id !== '11';
        // }
        return true
    })

    // Hari K:27-10-2023 News-start
    //Prachi T [07-12-2023] - commented for 1st release to hide NEWS_EVENTS from Watchlist sidetray 
    if (nCMOTMode !== NEWS_CMOT_MODE.CMOT_OFF) {
        const objNewsAndEvent = { id: '5', name: 'NEWS_EVENTS', icon: <div className='icon-16 icon-news icon-light onactive'></div>, tooltip: 'News & Events' };
        filteredArray?.splice(4, 0, objNewsAndEvent);
    } else { }
    //Prachi T [07-12-2023] - commented for 1st release to hide NEWS_EVENTS from Watchlist sidetray 
    // Hari K:27-10-2023 News-end


    if (objCFT.ALERT === FACILITY_NUM.ON) {
        const objAlert = { id: '9', name: 'ALERTS_NOTIFICATIONS', icon: <div><div className='icon-20 icon-alert icon-light onactive'>&nbsp;</div>{parseInt(nTriggerAlertCount) > 0 ? <div className='sticky-notification-count'>{nTriggerAlertCount}</div> : null}</div>, tooltip: 'Alerts' };
        filteredArray?.splice(8, 0, objAlert);
    } else { }

    // ---BT-113521_SrikanthRao_17-07-2023-end
    const { setIsGlobalSearch, isExpanded, setIsExpanded, isSideBar, chartUrl, scripOnExpand, setBIsSiderTrayOrderEntryOpen } = props;




    const dontMissInfo = useSelector(state => state.dontMiss.dontMissInfo);

    //Ameersha N - 22-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
    const handleCalulators = useCallback(() => {
        let calculators = objHamburgerMenu?.items?.find(eachItem => eachItem?.name === 'calculators');
        if (calculators && Object?.keys(calculators)?.length > 0) {
            if (!isGuestUser()) {
                return true;
            } else if (calculators?.guestMode === 1 && isGuestUser()) {
                return true;
            } else if (calculators?.guestMode === 0 && isGuestUser()) {
                return false;
            }
        } else {
            return true;
        }
    }, [objHamburgerMenu]);
    //Ameersha N - 22-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End



    const [sideContentId, setSideContentId] = useState(null);
    const [activeDontMissCardIndex, setActiveDontMissCardIndex] = useState(null);
    const [toggleSideContainer, setToggleSideContainer] = useState(false);
    const [activeMenu, setActiveMenu] = useState({}); //BT- 112339 : Watchlist || Side Tray || Closing functionality : ManasaB : 30/06/2023

    useWFHMessages('global_function', (e) => {
        if (e?.detail?.length > 0) {
            e?.detail?.forEach((eachType) => {
                switch (eachType) {
                    case GLOBAL_FUNCTION_TYPES.CLOSING_SIDETRAY:
                        
                        setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE?.ZERO_PERCENT }; });
                        setActiveMenu({});
                        break;

                    default:
                        break;
                }
            });
        }
    });

    // Vinit R 22-02-2023 Watchkist sidetray FAO fixes for orders, positions and holdings -- Start
    useEffect(() => {
        if (isSideBar === false) {
            setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE?.ZERO_PERCENT }; });
            setActiveMenu({});
            setToggleSideContainer(false);
            setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE?.ZERO_PERCENT }; });
            setActiveMenu({});
        }
    }, [setToggleSideContainer, setIsExpanded]);
    // Vinit R 22-02-2023 Watchkist sidetray FAO fixes for orders, positions and holdings -- End

    //BT- 112339 : Watchlist || Side Tray || Closing functionality : ManasaB : 30/06/2023 - Start
    useEffect(() => {
        if (toggleSideContainer === false && Object.keys(activeMenu).length > 0) {
            if (activeMenu.id === '2') {
                setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE?.FIFTY_PERCENT }; });
            }
            else {
                setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE?.TWENTY_FIVE_PERCENT }; });
            }
        }
    }, [toggleSideContainer, setIsExpanded, activeMenu]);
    //BT- 112339 : Watchlist || Side Tray || Closing functionality : ManasaB : 30/06/2023 - End
    const toggleClass = useCallback((key) => {
        setSideContentId(key);
    }, [setSideContentId]);

    useEffect(() => {
        if (!activeDontMissCardIndex && dontMissInfo?.length > 0) {
            setActiveDontMissCardIndex(dontMissInfo[0]?.id);
        }
    }, [dontMissInfo, activeDontMissCardIndex]);
    return (
        <>
            {(Object.keys(activeMenu).length > 0 && isExpanded?.containerLength !== SIDE_TRAY_EXPAND_PERCENTAGE?.ZERO_PERCENT) &&
                <SideContent sideContentId={sideContentId} setToggleSideContainer={setToggleSideContainer}
                    isExpanded={isExpanded} setIsExpanded={setIsExpanded} setActiveMenu={setActiveMenu}
                    chartUrl={chartUrl} scripOnExpand={scripOnExpand} sideTrayOrderEntryRef={props.sideTrayOrderEntryRef} setBIsSiderTrayOrderEntryOpen={setBIsSiderTrayOrderEntryOpen}
                />}
            {
                <div data-testid='sidetrayId' className={`sticky-sidebar-wrapper ${Object.keys(activeMenu)?.length ? 'close-watchlist' : 'open-watchlist'}`}>
                    <div className='sticky-sidebar'>
                        {filteredArray.map((each) => (
                            <BzToolTip key={each.id} TooltipMsg={each.tooltip} placement='left'>
                                <div className={`d-flex justify-content-center position-relative sticky-sidemenu cursor-pointer ${activeMenu?.id === each?.id ? 'active' : ''}`} onClick={() => {
                                    if (!isUserIsAGuest(each?.name === 'RECOMMENDATIONS' ? 'recommendataion' : each?.name === 'ORDER_TICKET' ? 'buy_sell' : each?.name === 'ORDERS_POSITIONS' ? "Portfolio" : each?.name === 'FUNDS' ? "Funds" : each?.name === 'CHART' ? "chart" : each?.name === "CALCULATORS" ? (!handleCalulators() ? "buy_sell" : '') : "")) { //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
                                        globalFunctionsEventDispatcher([GLOBAL_FUNCTION_TYPES.EXPANDING_SIDETRAY]); //BREEZE-305 :Watchlist Side tray- Order Cart Order entry :ManasaB : 20-11-2024 : SAT issues 
                                        setIsGlobalSearch(false);
                                        setTimeout(() => {
                                            dispatch(toastConfig({}));
                                        }, 50);
                                        _resetGridFeatures(WATCHLIST_GRID_REF); //Vaibhav Singh: 08-09-2023 : Keeping the state of selected scrip as it is 
                                        if (isGuestUser() && each?.id === '1') {
                                            const storedWatchlist = JSON.parse(getDecryptLocalStorage('GUEST_WATCHLIST'));
                                            if (storedWatchlist?.length > 1) {
                                                setActiveMenu(each);
                                                if (each?.id === '2') {
                                                    setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE?.FIFTY_PERCENT }; });
                                                } else {
                                                    setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE?.TWENTY_FIVE_PERCENT }; });
                                                };
                                            }
                                        } else {
                                            setActiveMenu(each);
                                            if (each?.id === '2') {
                                                setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE?.FIFTY_PERCENT }; });
                                            } else {
                                                setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE?.TWENTY_FIVE_PERCENT }; });
                                            };
                                        }
                                        setToggleSideContainer(true);
                                        toggleClass(each.name);
                                    } else { }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
                                }}>
                                    {each.icon}
                                </div>
                            </BzToolTip>
                        ))}
                    </div>
                </div>
            }
        </>
    );
};

export default memo(SideMenu);